<div class="header-cnt">
  
    <div *ngIf="visibleBurger" class="burger-cnt">
      <i class="fas fa-bars app-icon" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu"></i>
      <mat-menu #menu="matMenu">
        <div *ngFor="let item of menuTabs">
          <button *ngIf="item.enabled" mat-menu-item (click)="goToPage(item)">
            <span (click)="goToPage(item)">{{item.name}}</span>
          </button>
        </div>
        <!-- <button mat-stroked-button color="warn" (click)="goToCovid19Page()" > ⛑️ Alerta COVID-19</button> -->
      </mat-menu>
    </div>
    <div class="burger-cnt" *ngIf="visibleBack">
      <i class="fas fa-angle-left back-btn" (click)="goBack()"></i>
    </div>

    <!-- Logo ============================================= -->
    <div class="logo-cnt">
      <img *ngIf="showLogoImage != 'false'" src="assets/voyjaleas/logo/logoSmall.png" alt="logo" class="header-logo" (click)="goToHomePage()">
      <span *ngIf="showLogoImage === 'false'" class="instagram-logo">{{textLogo}}</span>
    </div>

<!--     <app-shopping-cart *ngIf="shoppingCart"></app-shopping-cart> -->

    <button mat-stroked-button *ngIf="visibleLogin" class="button-secondary" style="margin-right: 1rem;" (click)="loginScreen()">Iniciar sesión</button>
    <button mat-stroked-button *ngIf="visibleVideoCall" class="button" style="margin-right: 1rem;" (click)="goToCalendly()">Videollamada Gratis</button>
    <button mat-flat-button *ngIf="visibleRegister" style="margin-right: 1rem;" (click)="registerScreen()" color="primary">Registrarme</button>
  
  </div>